<template>
    <section class="container-fluid my-4">
        <h4 class="my-4">Relatório financeiro por <strong>turma</strong></h4>

        <form @submit.prevent="generateReportFinancialByTeam">

            <div class="row">

                <div class="form-group col-md-6">

                    <div class="mb-3">
                        <SearchableSelect
                            v-model="team_id"
                            :options="teams"
                            item-text="name"
                            item-value="id"
                            label="Turma"
                            placeholder="-- Selecione uma turma --"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Status dos Alunos <small class="text-secondary">(por padrão, quando vazio: Ativo, Concluído)</small></label>
                        <MultiSelect
                            v-model="studentStatus"
                            :options="statusOptions"
                        />
                    </div>

                    <div class="mb-3">
                        <SearchableSelect
                            v-model="service_type_id"
                            :options="services"
                            item-text="name"
                            item-value="id"
                            label="Tipo de Serviço (por padrão MENSALIDADE)"
                            placeholder="-- Selecione um tipo de serviço (opcional) --"
                        />
                    </div>

                    <div v-if="!loading" class="form-group text-center my-2">
                        <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
                            Gerar
                        </button>
                        <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
                            Limpar
                        </button>
                    </div>
                    <LoadingPage v-else />

                </div>

            </div>

        </form>

        <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
            VOLTAR
        </button>
    </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import { handleBlobError, studentStatusOptions } from "@/helpers";

export default {
    name: "ReportFinancialByTeam",
    components: {
        LoadingPage,
        SearchableSelect,
        MultiSelect,
    },
    data() {
        return {
            team_id: "",
            year: "",
            studentStatus: [],
            service_type_id: "",
            teams: [],
            services: [],
            loading: false,
            statusOptions: studentStatusOptions,
        };
    },
    methods: {
        async getTeams() {
            await api.get(`/teams?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
                this.teams = res.data.data;
            });
        },
        async getServices() {
            await api.get(`/service-types?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
                this.services = res.data.data;
            });
        },
        clearForm() {
            this.team_id = "";
            this.studentStatus = [];
            this.service_type_id = "";
        },
        async generateReportFinancialByTeam() {

            if (!this.team_id)
                return Toast.fire('Erro', 'Por favor, selecione uma turma.', "error");

            try {
                this.loading = !this.loading;

                const teamName = this.teams.filter((e) => e.id == this.team_id);

                await api
                    .post(`/exports/report-financial-by-team/${this.team_id}`, 
                        {
                            "student_status": this.studentStatus,
                            "service_type_id": this.service_type_id || null
                        },
                        {
                            responseType: "blob",
                        }
                    )
                    .then((response) => {
                        const blob = new Blob(
                            [response.data],
                            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," }
                        );

                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        a.download = `RelatorioFinanceiroPorTurma_${this.year} - ` + teamName[0].name.toUpperCase();
                        a.click();
                    });

            } catch (error) {
                handleBlobError(error, (message) => {
                    Toast.fire('Erro', message, "error");
                });
            }
            this.loading = !this.loading;
        },
    },
    mounted() {
        this.getTeams();
        this.getServices();
    },
};
</script>

<style scoped></style>